import AssessmentSystemLayout from "./AssessmentSystemLayout";

function AssessmentSystemApp() {
  return <AssessmentSystemLayout />;
}

export default AssessmentSystemApp;
